<template>
<div>
    <el-form label-width="180px" size="small" :model="dataForm" ref="refDataForm"  :rules="rules">
        <el-collapse v-model="activeNames">
            <!-- 时间 -->
            <el-collapse-item name="1"> 
                <template slot="title">
                    <h2 style="color:red">时间</h2>
                </template>
                <el-row>
                    <el-col :span="6">
                        <!-- value-format="yyyy-MM-dd" -->
                        <el-form-item label="询价时间:">
                            <el-date-picker
                                v-model="dataForm.bidStartTime"
                                style="width:100%"
                                placeholder="请选择询价时间"
                                type="datetime">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="逾期时间:">
                            <el-date-picker
                            v-model="dataForm.bidEndTime"
                            placeholder="请选择逾期时间"
                            style="width:100%"
                            type="datetime">
                            </el-date-picker>
                        </el-form-item>  
                    </el-col> 
                </el-row>
            </el-collapse-item>

            <!-- 基础信息 -->
            <el-collapse-item  name="2"> 
                <template slot="title">
                    <h2 style="color:red">基础信息</h2>
                </template>
                <!-- 案件信息 -->
                <el-row :wrap="true">
                    <el-col :span="6">
                        <el-form-item label="车辆编号">
                            <el-input v-model="dataForm.vehicleSn" placeholder="请输入车辆编号">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="报案号">
                            <el-input v-model="dataForm.caseSn" placeholder="请输入报案号">
                            </el-input>
                        </el-form-item>   
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车辆停放地">
                            <el-input v-model="dataForm.vehicleParkingArea" placeholder="请输入车辆当前停放地" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>
             
                    <el-col :span="6">
                        <el-form-item label="出险地点">
                            
                            <el-input v-model="dataForm.vehicleAccidentLocation" placeholder="请输入出险地点" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    
                </el-row>

                <!-- 保险公司信息 -->
                <el-row :wrap="true" :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="保险公司" prop="insurance.insureCompany">
                            <el-autocomplete
                                style="width:100%"
                                v-model="dataForm.insurance.insureCompany"
                                :fetch-suggestions="querySearchInsureCompany"
                                value-key="insureCompanyName"
                                placeholder="请输入保险公司"
                                @select="handleSelectInsureCompany"
                                clearable
                            ></el-autocomplete>
                        </el-form-item>

                        
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="分公司" prop="insurance.insureFiliale">
                            <el-input v-model="dataForm.insurance.insureFiliale" placeholder="请输入保险分公司">

                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="分支机构">
                            <el-input v-model="dataForm.insurance.insureBranch" placeholder="请输入保险分机构">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


                <!-- 车辆出厂信息1 -->
                <el-row :wrap="true" :gutter="20">
                    
                    <el-col :span="6">
                        <el-form-item label="登记日期">
                           
                            <el-date-picker
                            style="width:100%"
                            v-model="dataForm.factory.registerDate"
                            placeholder="请选择登记日期"
                            value-format="yyyy-MM-dd"
                            type="date">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车架号">
                            <el-input v-model="dataForm.factory.vin" placeholder="请输入车架号">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="变速箱类型">
                            <el-input v-model="dataForm.factory.gearboxType" placeholder="请输入变速箱类型">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    

                    
                    
                    <el-col :span="6">
                        <el-form-item label="发动机号">
                            <el-input v-model="dataForm.factory.engineNo" placeholder="请输入发动机号"> 
                            </el-input>
                        </el-form-item>   
                    </el-col>
                
                </el-row>
               <!-- 车辆出厂信息2 -->
                <el-row :wrap="true">
                    <el-col :span="6">
                        <el-form-item label="车辆型号(品牌型号)">
                            <el-input v-model="dataForm.factory.vehicleModel" placeholder="请输入车辆车型标志">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item  label="车型" prop="factory.vehicleTradeName">
                            <el-autocomplete
                                class="css-vehicle-modle"
                                style="width:100%"
                                v-model="dataForm.factory.vehicleTradeName"
                                :fetch-suggestions="querySearchModelName"
                                value-key="modelName"
                                placeholder="请输入车辆型号"
                            
                                ></el-autocomplete>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="排量">
                            <el-input v-model="dataForm.factory.vehicleDisplacement" placeholder="请输入排量">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="发票金额" >
                            <el-input v-model="dataForm.factory.invoiceValue">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    
                </el-row>

                
                <!-- 车辆当前信息 -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="车辆性质">
                            <el-input v-model="dataForm.current.useCharacter" placeholder="请输入车辆商用乘用">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    

                    <el-col :span="6">
                        <el-form-item label="所有人性质(车辆归属)">
                            <el-input v-model="dataForm.current.ownership" placeholder="请输入车辆的所属性质(公司/个人)">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <!-- 车辆当前信息 -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="车牌号" prop="current.plateNo">
                            <el-input v-model="dataForm.current.plateNo" placeholder="请输入车牌号">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="公里数">
                            <el-input v-model="dataForm.current.vehicleKim">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="是否二手车">
                            <el-select  style="width:100%" v-model="dataForm.current.blnTransfer" placeholder="是否二手车" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    
                    
                    <el-col :span="6">
                        <el-form-item label="是否盗抢车">
                            <el-select
                            style="width:100%"
                            v-model="dataForm.current.blnRobbery" placeholder="是否盗抢车" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>  
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车辆类型（）">
                            <el-input >
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="发证日期">
                           
                            <el-date-picker
                                style="width:100%"
                                v-model="dataForm.current.issueDate"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择询价时间"
                                type="date">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                   
                    <!-- <el-col :span="6">
                        <el-form-item label="乘用商用">
                            <el-input v-model="dataForm.current.passengerCommercial">
                            </el-input>
                        </el-form-item>
                    </el-col> -->
                </el-row> 

                <!-- --------------------------------- -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="保险金额">
                            <el-input v-model="dataForm.insureAmount">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="估损金额">
                            <el-input v-model="dataForm.damageCost">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车辆种类(事故类型)">
                            <el-input v-model="dataForm.vehicleAccidentType">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车损原因">
                            <el-input v-model="dataForm.vehicleDamageReason">
                            </el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row>

                    <el-col :span="6">
                        <el-form-item label="报价有效期">
                            <el-input v-model="dataForm.offeringDate">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="大票金额()">
                            <el-input>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="出险日期">
                            <el-date-picker 
                                style="width:100%"
                                type="datetime" v-model="dataForm.vehicleAccidentDate">

                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="实际价值(全损金额)">
                            <el-input v-model="dataForm.current.practicalValue">
                            </el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row>
                    

                    <el-col :span="6">
                        <el-form-item label="定损员姓名">
                            <el-input v-model="dataForm.insurance.surveyorName">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="定损员电话">
                            <el-input v-model="dataForm.insurance.surveyorPhone">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 事故备注 -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="事故备注">
                            <el-input type="textarea" v-model="dataForm.vehicleAccidentRemark" placeholder="请输入出险地点" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">

                        <el-tag  effect="dark" type="danger" v-if="dataForm.offeringSecond=='Y'">二次询价车辆</el-tag>
                    </el-col>

                </el-row>
            </el-collapse-item>

            <!-- 二次报价原因 -->
            <el-collapse-item name="3">
                <template slot="title">
                    <h2 style="color:red">二次报价原因</h2>
                </template>

                <el-row>
                    <el-input type="textarea" v-model="dataForm.offeringReason">
                    </el-input>
                     
                </el-row>
            </el-collapse-item>


            <el-collapse-item title="二次报价附件" name="4">
                <template slot="title">
                    <h2 style="color:red">二次报价附件</h2>
                </template>
                <el-row>
                    
                    <material-picker  @click.stop="showOfferingImageViewer" v-model="dataForm.offeringAttachment">
                    </material-picker>
                </el-row>
            </el-collapse-item>

            <!-- 出险信息 -->
            <el-collapse-item  name="5">
                <template slot="title">
                    <h2 style="color:red">出险信息</h2>
                </template>
                <el-row>

                    <el-col :span="6">
                        <el-form-item label="责任认定">
                            <el-input v-model="dataForm.damage.responsibility" placeholder="请输入责任认定" >
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车身电脑是否完整">
                            <el-select 
                                style="width:100%"
                                v-model="dataForm.damage.vehicleEcu" placeholder="请选择车身电脑是否完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>

                        
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="发动机电脑是否完好">
                            <el-select 
                                style="width:100%"
                                v-model="dataForm.damage.vehicleEcu" placeholder="请选择发动机电脑是否完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="发动机是否完好">
                            <el-select 
                                :disable="true"
                                style="width:100%"
                                v-model="dataForm.damage.engineGood" placeholder="请选择发动机是否完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>

                    <el-col :span="6">    
                        <el-form-item label="是否脱审">
                            <el-select 
                                style="width:100%"
                                v-model="dataForm.damage.delisting" placeholder="请选择是否脱审" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="人伤情况">
        
                            <el-input v-model="dataForm.damage.casualties" placeholder="请输入人伤情况" >
                            </el-input>

                        </el-form-item>
                        
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="天窗是否完好">
                            <el-select 
                                style="width:100%"
                                v-model="dataForm.damage.skylightGood" placeholder="请选择天窗是否完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否拆解">
                            <el-select 
                                style="width:100%"
                                v-model="dataForm.damage.assemble" placeholder="请选择是否拆解" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    

                    

                    <el-col :span="6">
                        <el-form-item label="变速箱完好">
                            
                            <el-select 
                            style="width:100%"
                                v-model="dataForm.damage.gearboxGood" placeholder="请选择变速箱完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>

                    </el-col>

                   

                    <el-col :span="6">
                        <el-form-item label="是否二次事故">
                            <el-select 
                                style="width:100%"
                                v-model="dataForm.current.secondaryAccident" placeholder="请选择是否二次事故" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="6">
                        <el-form-item label="车辆大架号完好">
  
                            <el-select 
                                style="width:100%"
                                v-model="dataForm.damage.steelSealNumber" placeholder="车辆大架号完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                

              
            </el-row>
            </el-collapse-item>

            <!-- 费用信息 -->
            <el-collapse-item  name="6">
                <template slot="title">
                    <h2 style="color:red">费用信息(由竞价单位承担)</h2>
                </template>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="停车费">
                            <el-input v-model="dataForm.cost.parkingFee">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="拆检费">
                            <el-input v-model="dataForm.cost.overhaulFee">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="拖车费">
                            <el-input v-model="dataForm.cost.towingFee">

                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="施救费">
                            <el-input v-model="dataForm.cost.salvageFee">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="其他费用">
                            <el-input v-model="dataForm.cost.otherFee">
                            </el-input> 
                        </el-form-item>
                    </el-col>
                </el-row>

                
                
            </el-collapse-item>

            <!-- 手续信息 -->
            <el-collapse-item  name="7">
                <template slot="title">
                    <h2 style="color:red">手续信息</h2>
                </template>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="手续是否齐全">
                            <el-select v-model="dataForm.procedure.procedureComplete" placeholder="手续是否齐全">
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>

                    </el-col>
                    <el-col :span="6" >
                        <el-form-item label="是否抵押">
                            <el-select v-model="dataForm.procedure.mortgage" placeholder="是否抵押" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                            
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" >
                        <el-form-item label="购置税本">
                            <el-select v-model="dataForm.procedure.purchaseTax" placeholder="是否有购置税本" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" >
                        <el-form-item label="是否有贷款">
                            <el-select v-model="dataForm.procedure.loan" placeholder="是否有贷款" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>

                  
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="组织机构代码证">
                            <el-select v-model="dataForm.procedure.organizationCodeCertificate" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="权益转让书">
                            <el-select v-model="dataForm.procedure.subrogationReceipt" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>


                    <el-col :span="6">
                        <!-- <el-form-item label="破案证书">
                            <el-select  placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item> -->
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车主身份证复印件">
                            <el-select v-model="dataForm.procedure.idCardCopy" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
        
                <el-row>
                   

                    <el-col :span="6">
                        <el-form-item label="钥匙">
                             <el-select v-model="dataForm.procedure.vehicleKey" placeholder="是否有钥匙" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>


                    <el-col :span="6">
                        <el-form-item label="车牌">
                            
                             <el-select v-model="dataForm.procedure.licencePlate" placeholder="是否有车牌" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select> 
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="行驶证">
                            <el-select v-model="dataForm.procedure.vehicleLicense" placeholder="是否有行驶证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="登记证书">
                            <el-select v-model="dataForm.procedure.registrationCertificate" placeholder="是否有登记证书" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>

                            
                        </el-form-item>
                    </el-col>
                </el-row>
            
            </el-collapse-item>

            <!-- 照片 -->
            <el-collapse-item  name="8">
                <template slot="title">
                    <h2 style="color:red">照片</h2>
                </template>
             <!--  v-bind:type="'image-viewer'" -->
                <material-picker  @click.stop="showImageViewer" v-model="dataForm.damage.imgUrls">
                </material-picker>
              
               <el-button @click="showImageViewer" type="danger"> (可翻转)显示预览</el-button>
            </el-collapse-item>
            
            <!-- 车300 评估 -->
        <el-collapse-item name="11">
            <template slot="title">
                <h2 style="color:red">车300评估结果</h2>
            </template>
            <el-button type="success" @click="handleGetEvaluate">获取评估结果</el-button>

             <el-tabs  type="card" @tab-click="handleEvaluateTabClick" >
                <el-tab-pane v-for="tab in dataForm.evaluate" :key="tab.modelId	" :label="tab.modelName" :name="tab.modelName">
                    <!-- <component :is="tab.component" v-bind="tab.props"></component> -->
                    <el-descriptions border>
                        <el-descriptions-item label="车型">
                            {{tab.modelName}}
                        </el-descriptions-item>
                        <el-descriptions-item label="品牌名">
                            {{tab.brandName	}}
                        </el-descriptions-item>
                        <el-descriptions-item label="系列名">
                            {{tab.seriesName}}
                        </el-descriptions-item>

                        <el-descriptions-item label="户籍地">
                            {{tab.cityName}}
                        </el-descriptions-item>

                        <el-descriptions-item label="预估里程">
                            {{tab.mileAge}}
                        </el-descriptions-item>

                        <el-descriptions-item label="新车指导价">
                            {{tab.modelPrice}}
                        </el-descriptions-item>

                        

                      

                        <el-descriptions-item label="出厂日期">
                            {{tab.regDate}}
                        </el-descriptions-item>
                    </el-descriptions>

                    <el-radio-group v-model="radioCondition" @change="handleChangeCondition($event,tab)">
                        <el-radio-button label="normal">车况一般</el-radio-button>
                        <el-radio-button label="good">车况良好</el-radio-button>
                        <el-radio-button label="excelent">车况优秀</el-radio-button>
                    </el-radio-group>

                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-statistic
                                :value="evaluatePrice.dealerLowBuyPrice"
                                title="车商最低收车价(万元)"
                            ></el-statistic>
                        </el-col>
                        <el-col :span="6">
                            <el-statistic
                                :value="evaluatePrice.dealerBuyPrice"
                                title="车商收车价(万元)"
                            ></el-statistic>
                        </el-col>
                        <el-col :span="6">
                            <el-statistic
                            :value="evaluatePrice.individualLowSoldPrice"
                            title="个人最低交易价(万元)"
                            ></el-statistic>
                        </el-col>

                        <el-col :span="6">
                            <el-statistic
                                :value="evaluatePrice.individualPrice"
                                title="个人交易价(万元)"
                            ></el-statistic>
                        </el-col>

                        <el-col :span="6">
                            <el-statistic
                                :value="evaluatePrice.dealerLowSoldPrice"
                                title="车商最低零售价(万元)"
                            ></el-statistic>
                        </el-col>
                        
                        <el-col :span="6">
                            <el-statistic
                                :value="evaluatePrice.dealerPrice"
                                title="车商零售价(万元)"
                            ></el-statistic>
                        </el-col>
                        <el-col :span="6">
                            <el-statistic
                                :value="evaluatePrice.dealerHighSoldPrice"
                                title="车商最高零售价(万元)"
                            ></el-statistic>
                        </el-col>
                    
                    </el-row>
                </el-tab-pane>
               
            </el-tabs>
        </el-collapse-item>

            <!-- 定级 -->
            <el-collapse-item name="9">
                
                <template slot="title">
                    <h2 style="color:red">定级/审核</h2>
                </template>

                <el-row>
                    <el-col :span="6">

                        <el-form-item label="车辆级别">
                            <el-select v-model="dataForm.check.vehicleLevelGrade">
                                <el-option
                                   v-for="dict in dict.type.vehicle_level_grade"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="事故类型">
                            <el-select v-model="dataForm.check.vehicleLevel" placeholder="事故类型" clearable>
                                <el-option
                                v-for="dict in dict.type.vehicle_level"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                >

                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col >
                    <el-col :span="6">
                        <el-form-item label="区域" prop="check.district">
                            <el-select v-model="dataForm.check.district" placeholder="案件状态" clearable>
                                <el-option
                                v-for="dict in dict.type.vehicle_district"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                >

                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                    </el-col>
                    <el-col :span="6">

                        <el-form-item label="案件状态">
                            <el-select v-model="dataForm.caseStatus" placeholder="案件状态" clearable>
                                <el-option
                                
                                    v-for="dict in dict.type.vehicle_case_status"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                    >
                                
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                    </el-col>
                    
                </el-row>
                
            </el-collapse-item>
            
            <!-- 报价信息 -->
            <el-collapse-item >
                <template slot="title">
                    <h2 style="color:red">报价审核</h2>
                </template>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="报价人id">
                            <el-input></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="报价人姓名">
                            <el-input></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="6">
                        <el-form-item label="报价人报价">
                            <el-input></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="6">
                        <el-form-item label="提交到保险公司报价">
                            <el-input></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-collapse-item>

            <!-- 委托信息 -->
            <el-collapse-item>
                <template slot="title">
                    <h2 style="color:red">委托信息</h2>
                </template>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="定损员姓名">
                            <el-input v-model="dataForm.entrust.insuranceCompanyName">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="定损员电话">
                            <el-input v-model="dataForm.entrust.insuranceCompanyPhone">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="车主姓名">
                            <el-input v-model="dataForm.entrust.vehicleOwnerName">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车主电话">
                            <el-input v-model="dataForm.entrust.vehicleOwnerPhone">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col>
                        <el-form-item label="备注">
                            <el-input v-model="dataForm.entrust.remark">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-collapse-item>
            <!-- 入库信息 -->
            <el-collapse-item>
                <template slot="title">
                    <h2 style="color:red">入库信息</h2>
                </template>

                <el-row :wrap="true">
                    <el-col :span="6">
                        <el-form-item label="委托协议">
                            <material-picker v-model="dataForm.storage.commitmentUrl">
                            </material-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="登记证书">
                            <material-picker v-model="dataForm.storage.registrationUrl">
                            </material-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="驾驶证">
                            <material-picker v-model="dataForm.storage.drivingLicenseUrl">
                            </material-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="身份证">
                            <material-picker v-model="dataForm.storage.identityCardUrl">
                            </material-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :wrap="true">
                    <el-col :span="6">
                        <el-form-item label="交管12123截图">
                            <material-picker v-model="dataForm.storage.trafficScreenshotUrl">
                            </material-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="保险单">
                            <material-picker v-model="dataForm.storage.policyUrl">
                            </material-picker>
                        </el-form-item>
                    </el-col>    
                    <el-col :span="6">
                        <el-form-item label="过户视频">
                            <material-picker v-model="dataForm.storage.transferUrl">
                            </material-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="备注信息">
                            <el-input v-model="dataForm.storage.remark"  placeholder="请输入备注" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-collapse-item>

            

        </el-collapse>

        <el-row type="flex" justify="center">
            
            <el-button v-if="intAddOrUpdate==0" @click="handleAdd" type="primary" warning>
                增加
            </el-button>
            <el-button v-if="intAddOrUpdate!=0" @click="handleUpdateAndCheck" type="success">
                修改(报价中)
            </el-button>

            <el-button v-if="intAddOrUpdate!=0" @click="handleUpdate" type="warning" warning>
                修改
            </el-button>
            
            <el-button @click="handleClose" type="danger" warning>
                关闭
            </el-button>
        </el-row>
    </el-form>
   
</div>
</template>

<script>
import {getVehileModelList} from '@/api/vehicleConfig/vehicleModel'
import {listInsurance} from '@/api/vehicleConfig/insurance'
import {addCase,getCase,updateCase,getEvaluateResults} from '@/api/vehicle/case'
import MaterialPicker from "@/components/Material/picker.vue"

export default {
    name:'Edit',
    components:{MaterialPicker},
    dicts:['sys_yes_no','vehicle_case_status','vehicle_district','vehicle_level','vehicle_level_grade'],

    created(){
        const caseId=this.$route.query.caseid;
    
        if(caseId){
            //设置编辑状态
            this.intAddOrUpdate=1;
            // 通过caseId 获取详情
            this.handleGetDetail(caseId);
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm=>{
            if(to.query.caseid!=vm.caseId){
            vm.caseId=to.query.caseid;
                // 通过caseId 获取详情
                vm.handleGetDetail(vm.caseId);
            
            }
        });
    },
    
    data(){
        return{
            radioCondition:'normal',
            evaluatePrice:{},
            intAddOrUpdate:0,//0-add,1-update
            activeNames:['0','1','2','3','4','5','6','7','8','9','10','11'],
            dataForm:{
                bidStartTime:'',//询价时间(竞价开始)
                bidEndTime:'',//逾期时间(竞价结束)
                caseStatus:'',//案件状态
                vehicleSn:'', //车辆编号
                caseSn:'',//报案号
                vehicleParkingArea:'',//车辆停放地

                useCharacter:'',// 车辆使用性质

                vehicleDisplacement:'',//排量
               
                vehicleAccidentType:'',//事故类型
                vehicleDamageReason:'',//车损原因
                insureAmount:'',//保险金额
                
                actualAmount:'',//实际金额
                damageCost:'',//估损金额

                offeringDate:'',// 报价有效期
                offeringAttachment:'',
                //出厂信息
                factory:{
                    vin:'',//车架号
                    engineNo:'',//发动机号
                    registerDate:'',//登记(注册)日期
                    vehicleModel:'',//车辆型号(行车证)
                    vehicleTradeName:'',//车型型号；传播名
                    gearboxType:'',// 变速箱类型
                    vehicleDisplacement:'',//汽车排量
                    invoiceValue:'',//发票金额
                },

                //当前车辆信息
                current:{
                    plateNo:'',//车牌号
                    blnTransfer:'',//是否过户
                    vehicleKim:'',//公里数
                    issueDate:'',//发证日期
                    passengerCommercial:'',//乘用商用
                    practicalValue:'',//实际价值
                    ownership:'',//所有人性质
                },

                //车损信息
                damage:{
                    responsibility:'',//责任认定
                   
                    vehicleEcu:'',//车身电脑
                    engineEcu:'',//发动机电脑
                    engineGood:'',//发动机是否完好
                    delisting:'',//是否脱审
                    casualties:'',//人伤情况
                    skylightGood:'',//天窗是否完好
                    assemble:'',//是否拆解
                    imgUrls:[],//显示的图片列表
                  
                },

                insurance:{
                    insureCompany:'',// 保险公司
                    insureFiliale:'',// 保险分公司
                    insureBranch:'',// 分支机构
                    surveyorName:'', //定损员姓名
                    surveyorPhone:'',//定损员电话
                    insuranceId:'',//保险公司id
                },
                // 费用信息
                cost:{
                    overhaulFee:'',//拆检费
                    otherFee:'',//其他费用
                    parkingFee:'',//停车费
                    salvageFee:'',//施救费
                    towingFee:'',//拖车费
                },

                //手续信息
                procedure:{
                    procedureComplete:'',
                    mortgage:'',//是否抵押
                    licencePlate:'',//车牌
                    loan:'',//是否有贷款
                    idCardCopy:'',//身份证复印件
                    organizationCodeCertificate:'',//组织机构代码证是否有
                    purchaseTax:'',//购置税本
                    registrationCertificate:'',//登记证书是否有
                    subrogationReceipt:'',//权益转让书
                    vehicleKey:'',//车钥匙
                    vehicleLicense:'',//行驶证
                },
                //审核
                check:{
                    caseId:'',
                    checkUserId:'',
                    district:'',
                    isCheck:'',
                    finalBidTime:'',
                    remark:'',
                    vehicleLevel:'',
                    vehicleLevelGrade:'',
                    checkTime:'',
                },
                //委托信息
                entrust:{
                    insuranceCompanyName:'',
                    insuranceCompanyPhone:'',
                    vehicleOwnerName:'',
                    vehicleOwnerPhone:'',
                    remark:'',
                },
                storage:{
                    commitmentUrl:[],//委托协议
                    registrationUrl:[], //登记证书
                    drivingLicenseUrl:[],//驾驶证
                    identityCardUrl:[], //身份证
                    trafficScreenshotUrl:[],//交管截图
                    policyUrl:[],//保险单，
                    transferUrl:[],//过户视频
                    remark:'',

                }
            },
            //检查规则
            rules: {
                'insurance.insureCompany': [
                    { required: true, message: '保险公司不能为空', trigger: 'blur' },
                ],
                'current.plateNo':[
                    { required: true, message: '车牌号不能为空', trigger: 'blur' },
                ],
                'factory.vehicleTradeName':[
                    { required: true, message: '请输入车辆型号', trigger: 'blur' },
                ],
                'insurance.insureFiliale':[
                    { required: true, message: '分公司不能为空', trigger: 'blur' },
                ],
                'check.district':[
                    { required: true, message: '区域不能为空', trigger: 'blur' },
                ],
            }
        }
    },

    methods:{


        handleEvaluateTabClick(tab, event){
           
            const index=tab.index;
            this.radioCondition="normal"
            this.evaluatePrice=this.dataForm.evaluate[index].normal;
        },
        //切换 车况
        handleChangeCondition(value,param){
            
            if (value=="good"){
                
                this.evaluatePrice=param.good;
            }

            if(value=="normal"){
                this.evaluatePrice=param.normal;
                
            }
            if(value=="excelent"){
                this.evaluatePrice=param.excellent;
                
               
            }

        },

        handleClose() {
            const obj = { path: "/vehicle-insure/list" };
            this.$tab.closeOpenPage(obj);
        },
        
        //增加素材
        handleAdd(){
            this.$refs['refDataForm'].validate((valid) => {
            // 直接提交    
            if(valid){
                
                var para=this.dataForm;
                addCase(para).then(res=>{
                    /**
                     * 增加成功后
                     */
                    if(res.success){
                        this.handleClose();
                        this.$message.success("增加成功");
                    }
                })
                .catch(error=>{

                })
            }
            });
        },

        // 修改
        handleUpdate(){
            this.$refs['refDataForm'].validate((valid) => {
            // 直接提交    
            if(valid){
                this.dataForm.damage.imgUrlsJson=JSON.stringify(this.dataForm.damage.imgUrls)
                var para=this.dataForm;
                updateCase(para).then(res=>{
                    if(res.success){
                        this.$message.success("修改成功");
                        this.handleClose();
                    }else{
                        this.$message.error("修改失败");
                    }
                })
                .catch(error=>{

                });
            }
            });
        },

        //审核并修改
        handleUpdateAndCheck(){
            this.dataForm.damage.imgUrlsJson=JSON.stringify(this.dataForm.damage.imgUrls)
            var para=this.dataForm;
            this.dataForm.caseStatus="quotation"; //审核报价中
            updateCase(para).then(res=>{
                if(res.success){
                    this.$message.success("修改成功");
                    this.handleClose();
                }else{
                    this.$message.error("修改失败");
                }
            })
            .catch(error=>{

            });
        },
        showImageViewer(){
           
            const $viewer=this.$viewerApi({
                images:this.dataForm.damage.imgUrls, 
            })
        },
        showOfferingImageViewer(){
            const $viewer=this.$viewerApi({
                images:this.dataForm.offeringAttachment, 
            })
        },
        //显示素材详情
        handleGetDetail(caseId){
            // 获取详情
            getCase(caseId)
            .then(res=>{
                if(res.data.entrust==null){
                    res.data.entrust=this.dataForm.entrust;
                }
                if(res.data.storage==null){
                    res.data.storage=this.dataForm.storage;
                }
                this.dataForm=res.data;

            
               
                let data=this.dataForm.damage.imgUrls
            if(!Array.isArray(data)){
                this.dataForm.damage.imgUrls=JSON.parse(data);
            } 
            data=this.dataForm.storage.commitmentUrl
            if(!Array.isArray(data)){
                this.dataForm.storage.commitmentUrl=JSON.parse(data);
            }
            
            data=this.dataForm.storage.drivingLicenseUrl
            if(!Array.isArray(data)){
                this.dataForm.storage.drivingLicenseUrl=JSON.parse(data);
            }
            data=this.dataForm.storage.identityCardUrl    
            if(!Array.isArray(data)){
                this.dataForm.storage.identityCardUrl=JSON.parse(data);
            }

            data=this.dataForm.storage.policyUrl
            if(!Array.isArray(data)){
                this.dataForm.storage.policyUrl=JSON.parse(data);
            }
            data=this.dataForm.storage.registrationUrl
            if(!Array.isArray(data)){
                this.dataForm.storage.registrationUrl=JSON.parse(data);
            }
            data=this.dataForm.storage.trafficScreenshotUrl
            if(!Array.isArray(data)){
                this.dataForm.storage.trafficScreenshotUrl=JSON.parse(data);
            }
            data=this.dataForm.storage.transferUrl
            if(!Array.isArray(data)){
                this.dataForm.storage.transferUrl=JSON.parse(data);
            }}
            ).catch(error=>{
                console.log(error);
            });
        },

        querySearchModelName(queryString, callback){
            
            getVehileModelList({'modelName':queryString}).then(res=>{
                callback(res.data);
            })
        },

        querySearchInsureCompany(queryString,callback){
            var para={"insureCompany":queryString};
            listInsurance(para).then(res=>{
             
                callback(res.data);
            })
        },

        handleSelectInsureCompany(item){
            this.dataForm.insurance.insuranceId=item.id
            // this.dataForm.insurance.insureCompany=item.insuranceCompanyName
        },

        /**
         * 日期差
         * @param date1 
         * @param date2 
         */
        monthDiff(date1, date2) {
            const d1 = new Date(date1);
            const d2 = new Date(date2);
            let months;
            
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months += d2.getMonth() - d1.getMonth();
            
            // 如果需要考虑天数差异
            if (d2.getDate() < d1.getDate()) {
                months--;
            }
            return months;
        },

        handleGetEvaluate(){
            //弹出对话框 输入 里程数
            const now = new Date();
            
            /***
            * 
            */
            const monthCount = this.monthDiff(this.dataForm.factory.registerDate,now)+1;
            let vehicleKim=monthCount*1250;
            /**
             * 不足1万
             */
            if (vehicleKim<10000) {
              vehicleKim=10000;  
            }

            this.$prompt('请输入公里数', '提示', {
                inputValue: vehicleKim,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^[0-9]+$/,
                inputErrorMessage: '公里数格式不正确,只能输入数字'
                }).then(({ value }) => {
                    vehicleKim=value;
                    this.doGetEvaluateResults(vehicleKim);
                }).catch((error) => {

                    this.$message({
                        type: 'info',
                        message: error
                    });  
                      
                });
        },

        doGetEvaluateResults(vehicleKim){
            const caseId=this.$route.query.caseid;
            var para={"vin":this.dataForm.factory.vin,
                "plateNo":this.dataForm.current.plateNo,
                "regDate":this.dataForm.factory.registerDate,
                "vehicleKim":vehicleKim,
                "caseId":caseId,
            }
            
            
            if(para.vehicleKim=== null || para.vehicleKim === undefined){
                this.$message.error("请检查公里数");
                return;
            }

           
            getEvaluateResults(para).then(res=>{
                
                if(res.success){
                    this.$message.success("增加成功");
                    this.handleGetDetail(para.caseId);
                }else{
                    this.$message.error("增加失败");
                }
                
            }).catch(error=>{
              
                this.$message.error("增加异常");
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.css-vehicle-modle{
    min-width: 200px;
}
</style>